import Actividades from "./Actividades";
import Citas from "./Citas";
import Planes from "./Planes";

const PlanCuidado = () => {
  return (
    <div>
      <div className="row">
        <div className="col-12 col-xl-12">
          <Planes />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-xl-12">
          <Actividades />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-xl-12">
          <Citas />
        </div>
      </div>
    </div>
  );
};

export default PlanCuidado;
